module.exports = __webpack_public_path__ + "static/Picture2-1568ae5a87016fc1c9feb3fef89a9aa6.jpg";